import { render, staticRenderFns } from "./SummaryItem.vue?vue&type=template&id=5b51a2a5&scoped=true&"
import script from "./SummaryItem.vue?vue&type=script&lang=js&"
export * from "./SummaryItem.vue?vue&type=script&lang=js&"
import style0 from "./SummaryItem.vue?vue&type=style&index=0&id=5b51a2a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b51a2a5",
  null
  
)

export default component.exports